import React, {ReactNode} from "react";
import {Box, useTheme} from "@mui/material";
import {CustomDrawer, drawerWidth} from "../drawer/CustomDrawer";
import {DrawerContent} from "../drawer/DrawerContent";
import {CustomAppBar} from "../app-bar/CustomAppBar";

export function BasePage(props: {
  children?: ReactNode,
}) {
  const theme = useTheme();

  return (
    <Box sx={{
      display: 'grid',
      height: '100%',
      width: '100%',
      backgroundColor: theme.palette.background.default,
      gridTemplateRows: '64px auto',
      [theme.breakpoints.down('sm')]: {  // Toolbar also changes height
        gridTemplateRows: '56px auto',
      }
    }}>
      <CustomAppBar/>
      <Box sx={{
        height: '100%',
        overflow: 'hidden',
        display: 'grid',
        zIndex: 1,
        gridTemplateColumns: drawerWidth + 'px auto',
        backgroundColor: theme.palette.background.default,
      }}>
        <CustomDrawer>
          <DrawerContent/>
        </CustomDrawer>
        <Box component={'main'} sx={{
          overflow: 'auto',
          [theme.breakpoints.down('md')]: {
            // Include drawer grid column
            gridColumnEnd: 'span 2',
            // Less spacing on small screens
            paddingTop: theme.spacing(1),
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(1),
          },
          paddingTop: theme.spacing(1),
          paddingLeft: theme.spacing(3),
          paddingRight: theme.spacing(3),
        }}>
          {props.children}
        </Box>
      </Box>
    </Box>
  );
}
